

















import { Vue, Component } from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Accordion from '@/components/Accordion.vue';
import Loader from '@/components/Loader.vue';

import { DetailPartnershipResponse } from '@/libs/api.interfaces';
import api from '@/libs/api';
import BalanceBox from './BalanceBox.vue';

@Component({
  components: {
    LayoutContent,
    Button,
    Loader,
    BalanceBox,
    Accordion,
  },
})

export default class BalanceJumbotron extends Vue {
  balance = 0;
  loading = true;
  merchantName = '';

  async mounted() {
    try {
      const { data } = await api.get<DetailPartnershipResponse>('/disbursement/partner', {
        params: {
          id: this.$route.params.id,
        },
      });

      this.merchantName = data.name;
      this.balance = data.balance;
    } catch (err) {
      console.error(err);

      throw err;
    }
    this.loading = false;
  }
}
